export const beforeAddValidate = (tag, existingTags) => tag?.trim() && !existingTags?.some((x) => x?.trim()?.toLowerCase() === tag?.trim()?.toLowerCase());
